"use strict";

export function initInScope ($scope) {
    let $navbar = $scope.find('.js-navbar'),
        $navbarToggle = $scope.find('.js-navbar__toggle'),
        $logoColored = $scope.find('.js-xs-logo-colored'),
        $logoWhite = $scope.find('.js-xs-logo-white')
        /*$subnavToggle = $navbar.find('.js-subnav-toggle');*/

    $navbarToggle.on('click', function (evt) {
        evt.preventDefault();
        $navbarToggle.toggleClass('active');
        $navbar.toggleClass('is-open');
        $('body').toggleClass('nav-open');
        if($logoWhite.length > 0 && $logoColored.length > 0) {
            if($('body').hasClass('nav-open')) {
                $logoColored.removeAttr('hidden');
                $logoWhite.attr('hidden','hidden');
                $(".fullcal-nav").attr('hidden','hidden');
            } else {
                $logoWhite.removeAttr('hidden');
                $logoColored.attr('hidden','hidden');
                $(".fullcal-nav").removeAttr('hidden');
            }
        }
    });

    /*$subnavToggle.click(function(evt) {
        evt.preventDefault();

       if ($(this).closest('.has-subnav').find('.sub-nav').length > 0) {
           $(this).closest('.has-subnav').find('.sub-nav').first().toggleClass('is-open');
       }
       else if ($(this).closest('.sub-nav').length > 0) {
           $(this).closest('.sub-nav').toggleClass('is-open');
       }
    });*/

}